import { TextGradientScroll } from "@/components/ui/text-gradient-scroll";
import React from "react";

const Text = () => {
  return (
    <section>
      <div className="container py-24 lg:py-48 w-full max-w-3xl mx-auto p-4 items-center">
        <div className="flex p-4 text-3xl md:text-4xl text-center mx-auto  flex flex-col items-start justify-end pointer-events-auto">
          <TextGradientScroll text="Code is more than a tool – it’s a language of innovation. I build websites that don’t just look great but also perform seamlessly, scale efficiently, and drive results." />
        </div>
      </div>
    </section>
  );
};

export default Text;
